<!-- Parité V1 : [responsive] et [minY] retirés (inputs supprimés de p-dialog en PrimeNG 21, sans effet moderne) ;
     <p-footer> remplacé par <ng-template pTemplate="footer"> (équivalent v21). Tout le reste identique. -->
<p-dialog header="Êtes vous toujours là ?" [(visible)]="display"  [closable]="false" [modal]="true" [style]="{width: '550px', minWidth: '200px'}"
         [baseZIndex]="10000">

      <div class="row">
        <br>
             <p>
              Dans {{remainingTime}} secondes votre session atteindra sa limite de {{timeout / 60000}} minutes.
              Afin de garantir la sécurité de votre compte, vous serez automatiquement déconnecté(e).
              Vous pouvez choisir de prolonger votre session ci-dessous.
             </p>
        <br>
      </div>
        <ng-template pTemplate="footer">
          <div class="bco-tools d-flex justify-content-end">
              <div class="item mr-2">
                <a (click)="disconnect()">Me déconnecter</a>
              </div>

              <div class="item">
                <a (click)="continue()">Continuer sur Espace PRO Client</a>
              </div>
          </div>
        </ng-template>
</p-dialog>
<!-- Parité V1 : la balise <body> imbriquée (HTML invalide mais toléré) est remplacée par un <div>
     portant le même id "page-top" — les navigateurs ignoraient déjà la balise body imbriquée en V1,
     le DOM effectif est identique. -->
<div id="page-top">
  <app-nav-menu *ngIf="headerVisible && !IsloginPage" (isfullscreen)="setFullscreen($event)"></app-nav-menu>
  <app-nav-menu-anonymous *ngIf="!headerVisible && isAnonymous && !IsloginPage"></app-nav-menu-anonymous>
  <div *ngIf="!headerVisible && IsloginPage && isAnonymous"></div>
  <div [ngClass]="{ 'app-body':  !IsloginPage && !IslikeloginPage}">
    <div [ngClass]="{ 'app-container':  !IsloginPage && !IslikeloginPage }">
      <div class="bco-breadcrumb" *ngIf="headerVisible">
        <app-breadcrumb></app-breadcrumb>
      </div>
      <app-loader></app-loader>
      <app-error></app-error>
      <router-outlet></router-outlet>
    </div>
    <app-footer *ngIf="!IsloginPage && !IslikeloginPage"></app-footer>
  </div>
  <div *ngIf="!IsloginPage && !IslikeloginPage">
    <a id="cRetour" class="cRetour border rounded d-inline scroll-to-top" (click)="goToTopPage()"
       [class.cVisible]="goToTopButtonVisible" [class.cInvisible]="!goToTopButtonVisible">
      <i class="fas fa-angle-up"></i>
    </a>
    </div>
</div>
